import styled from '@emotion/styled'

import React from 'react'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import HeroBase, * as HeroRecipe from '@segment/matcha/recipes/Hero'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import RequestIntegration from '@segment/templates/Forms/RequestIntegration'
import Footer from '@segment/templates/Footer'
import Navigation from '@segment/templates/Navigation'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

import Layout from '@segment/next-shared/layout'

import ogImageJpeg from './assets/OgRequestIntegration.jpg'

const copy = {
  heading: `Integration Request`,
  description: `Are you the owner of the tool requested? `,
}

const link = {
  text: `Build your own integrations!`,
  url: `/partners/integration/`,
}

const IntegrationRequestView = () => {
  const pageConfig = usePageConfig()

  return (
    <AppearanceProvider appearance="twilioLight">
      <Layout
        pageTitle="Request an Integration | Twilio Segment"
        pageDescription="Twilio Segment is a customer data platform (CDP) that helps you collect, clean, and activate your customer data."
        pageOG={ogImageJpeg}
      >
        <Navigation />
        <Main>
          <HeroBase variant="centered">
            <HeroRecipe.Contents>
              <CopyTextBase centered={true}>
                <CopyText.Heading variant="h2" tag="h1">
                  {copy.heading}
                </CopyText.Heading>
                <CopyText.Description variant="pLarge" tag="h2">
                  {copy.description}
                  <a href={getAbsoluteUrl(link.url, pageConfig)}>{link.text}</a>
                </CopyText.Description>
              </CopyTextBase>

              <RequestIntegration />
            </HeroRecipe.Contents>
          </HeroBase>
        </Main>
      </Layout>
      <Footer />
    </AppearanceProvider>
  )
}

const Main = styled.main`
  background: ${({ theme }) => theme.palette.twilio.gray[10]};
`

export default IntegrationRequestView
